<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มการจับคู่ประเภทการลงเวลา</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title v-if="dutyMatchingInit['3rd_party_duty_code']">
              {{ dutyMatchingInit['3rd_party_duty_code'] }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="dutyMatchingInit.company_duty">
              {{
                `${dutyMatchingInit.company_duty.title_th} - 
                (ประเภท: ${dutyMatchingInit.company_duty.duty_type.title_th},
                 รหัส: ${dutyMatchingInit.company_duty.duty_code})`
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสประเภทการลงเวลาจาก 3rd - Party
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="dutyMatching['3rd_party_duty_code']"
          :rules="[
            (v) => !!v || 'โปรดระบุประเภทการลงเวลา',
            (v) => (v && v.length <= 1) || 'Limit 1 characters',
          ]"
          required
          clearable
          @change="checkEmpty($event, '3rd_party_duty_code')"
          counter="1"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ประเภทการลงเวลาที่ต้องการใช้งาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="dutyMatching.company_duty_uuid"
          :rules="[(v) => !!v || 'โปรดระบุประเภทการลงเวลา']"
          :items="
            duties.map((duty) => ({
              text: `${duty.title_th} - (ประเภท: ${duty.duty_type.title_th}, รหัส: ${duty.duty_code})`,
              ...duty,
            }))
          "
          item-text="text"
          item-value="company_duty_uuid"
          outlined
          dense
        >
          <template v-slot:item="{ item }">
            <template>
              <v-list-item-content>
                <v-list-item-title>{{ item.title_th }}</v-list-item-title>
                <v-list-item-subtitle>
                  ประเภท: {{ item.duty_type.title_th }}, รหัส:
                  {{ item.duty_code }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isDutyMatchingDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::duty_matching:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::duty_matching:create')"
            tabindex="3"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::duty_matching:update')"
            tabindex="3"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    dutyMatching: {
      type: Object,
    },
    dutyMatchingInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isDutyMatchingDataChange() {
      if (
        this.dutyMatching['3rd_party_duty_code'] !==
          this.dutyMatchingInit['3rd_party_duty_code'] ||
        this.dutyMatching.company_duty_uuid !==
          this.dutyMatchingInit.company_duty_uuid
      ) {
        this.$emit('isDutyMatchingDataChange', true)
        return true
      }
      this.$emit('isDutyMatchingDataChange', false)
      return false
    },
    duties() {
      return this.$store.state.duty.duties
    },
  },
  created() {
    const { company_uuid } = this.$store.state.authentication.company

    const payload = {
      company_uuid,
      params: {
        dpc: 'company-duty-matching-to-list-company-duty',
      },
    }
    this.fetchDuties(payload)
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchDuties: 'duty/fetchDuties',
      addDutyMatching: 'duty/addDutyMatching',
      editDutyMatching: 'duty/editDutyMatching',
      deleteDutyMatching: 'duty/deleteDutyMatching',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.dutyMatching[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบจับคู่ประเภทการลงเวลา',
        value: `${this.dutyMatching['3rd_party_duty_code']}: ${this.dutyMatching.company_duty.title_th}`,
        item: this.dutyMatching,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(dutyMatching) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteDutyMatching({
        companyUUID: company_uuid,
        companyDutyMatchingUUID: dutyMatching.company_duty_matching_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const newDutyMatching = {
          '3rd_party_duty_code': this.dutyMatching['3rd_party_duty_code'],
          company_duty_uuid: this.dutyMatching.company_duty_uuid,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.addDutyMatching({
          companyUUID: company_uuid,
          dutyMatching: newDutyMatching,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const dutyMatchingUpdate = {
          '3rd_party_duty_code': this.dutyMatching['3rd_party_duty_code'],
          company_duty_uuid: this.dutyMatching.company_duty_uuid,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.editDutyMatching({
          companyUUID: company_uuid,
          companyDutyMatchingUUID: this.dutyMatching.company_duty_matching_uuid,
          dutyMatching: dutyMatchingUpdate,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isDutyMatchingDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
